export default __webpack_public_path__ + "static/media/unique_pedagogy.38511fa1.png";